// ©2024 Austin App House. All rights reserved.
import React from 'react';
import SpiralLoader from './SpiralLoader';

const Loader = ({ size = 'md', className = '' }) => (
  <div className={`wurqly-spiral-loader-wrap${className ? ` ${className}` : ''}`} role="status" aria-live="polite" aria-label="Loading">
    <SpiralLoader size={size} />
  </div>
);

export default Loader;
